import { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { Head, Card, Stat, Empty, Meter, KV, Tag } from "../components/bits";

export default function Progression() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/progression").then((r) => setP(r.data)); }, []);
  if (!p) return <Empty>Loading…</Empty>;
  const prev = [...p.ladder].reverse().find((l) => (l.points ?? l.xp) <= (p.points ?? p.xp))?.points ?? 0;
  return (
    <div data-testid="progression-page">
      <Head title="My progress" sub="Points reward process only: lessons finished, quizzes passed, trades you reviewed and strategies you wrote up. Never returns, and never the number of trades you take." />
      <Card testId="level-card"><div className="flex items-baseline gap-3"><div className="stat mono" data-testid="level-name">{p.level}</div><Tag kind="ok">{p.points ?? p.xp} points</Tag>{p.next_level && <span className="sub" style={{ margin: 0 }}>{(p.next_points ?? p.next_xp) - (p.points ?? p.xp)} points to {p.next_level}</span>}</div>
        <Meter value={(((p.points ?? p.xp) - prev) / Math.max(1, (p.next_points ?? p.next_xp) - prev)) * 100} />
        <div className="flex gap-2 flex-wrap mt-3">{p.ladder.map((l) => <Tag key={l.name} kind={(p.points ?? p.xp) >= (l.points ?? l.xp) ? "ok" : ""}>{l.name} · {l.points ?? l.xp}</Tag>)}</div></Card>
      <div className="grid g4 mt-4">
        <Stat label="Lessons done" value={p.lessons_done} sub="+10 points each" />
        <Stat label="Quizzes passed" value={p.quizzes_passed} sub="+200 points each (≥80%)" />
        <Stat label="Trades you reviewed" value={p.trades_reviewed ?? 0} sub={`+8 points each · max ${p.daily_review_cap ?? 5} a day`} />
        <Stat label="Strategies written up" value={p.strategies_documented} sub="+50 points each" />
      </div>
      <Card className="mt-4" title="How you earned your points" testId="points-history">
        {(p.breakdown || []).map((b) => <KV key={b.what} k={`${b.what} — ${b.count} × ${b.each}`} v={<b>{b.points} points</b>} />)}
        <KV k={<b>Total</b>} v={<b data-testid="points-total">{p.points ?? p.xp} points</b>} />
      </Card>
      <Card className="mt-4" title="Recent quiz attempts">{!p.recent_attempts.length ? <div className="sub">No attempts yet.</div> : p.recent_attempts.map((a) => <KV key={a.id} k={`${fmtDate(a.created_at)} · ${a.course_name || a.course_id}`} v={`${a.pct}%`} />)}</Card>
    </div>
  );
}
